import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PopinContainerComponent } from '@shared/components/popin-container';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { TitledContent } from '@components/titled-content/models';

@Component({
  selector: 'app-titled-content',
  imports: [PopinContainerComponent, HandleHtmlLinksDirective, TitleComponent],
  templateUrl: './titled-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitledContentComponent {
  data = inject(DIALOG_DATA) as TitledContent;
}
